import { render, staticRenderFns } from "./CreateBankAccount.vue?vue&type=template&id=7d2872f8&scoped=true&"
import script from "./CreateBankAccount.vue?vue&type=script&lang=ts&"
export * from "./CreateBankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBankAccount.vue?vue&type=style&index=0&id=7d2872f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2872f8",
  null
  
)

export default component.exports